import { Component } from '@angular/core';
import { VehicleRoadTaxDeleteButtonComponent } from '../vehicle-road-tax-delete-button/vehicle-road-tax-delete-button.component';
import { ListItemMenuContainerComponent } from '../../../../../shared/components/containers/list-item-menu-container/list-item-menu-container.component';
import { BaseListItemMenuComponent } from '../../../../../shared/base-classes/base-list-item-menu.component';

@Component({
	selector: 'app-vehicle-road-taxes-list-item-menu',
	templateUrl: 'vehicle-road-taxes-list-item-menu.component.html',
	imports: [
		VehicleRoadTaxDeleteButtonComponent,
		ListItemMenuContainerComponent,
	],
})
export class VehicleRoadTaxesListItemMenuComponent extends BaseListItemMenuComponent {}
